import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const ChannelMembershipType = iotsUtils.fromList(
	constants.chat.channel.channelMembershipTypes
);
